import { api } from './api';

// Variants belong to a holiday. A holiday must always have exactly one
// default variant — the model layer takes care of demoting siblings, the
// frontend just calls setDefault.
export const holidayVariantsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getHolidayVariants: build.query({
      query: (holidayId) => ({ url: `holiday/${holidayId}/variants`, method: 'GET' }),
      transformResponse: (r) => r.data,
      providesTags: (result, _e, holidayId) => [
        { type: 'HolidayVariants', id: `holiday-${holidayId}` },
      ],
    }),
    createHolidayVariant: build.mutation({
      query: ({ holidayId, ...body }) => ({
        url: `holiday/${holidayId}/variant`,
        method: 'POST',
        body: JSON.stringify(body),
      }),
      invalidatesTags: (_r, _e, { holidayId }) => [
        { type: 'HolidayVariants', id: `holiday-${holidayId}` },
      ],
    }),
    updateHolidayVariant: build.mutation({
      query: ({ id, holidayId, ...body }) => ({
        url: `holiday-variant/${id}`,
        method: 'PUT',
        body: JSON.stringify(body),
      }),
      invalidatesTags: (_r, _e, { holidayId }) => [
        { type: 'HolidayVariants', id: `holiday-${holidayId}` },
      ],
    }),
    deleteHolidayVariant: build.mutation({
      query: ({ id }) => ({ url: `holiday-variant/${id}`, method: 'DELETE' }),
      invalidatesTags: (_r, _e, { holidayId }) => [
        { type: 'HolidayVariants', id: `holiday-${holidayId}` },
      ],
    }),
    setHolidayVariantDefault: build.mutation({
      query: ({ id }) => ({ url: `holiday-variant/${id}/default`, method: 'PUT' }),
      invalidatesTags: (_r, _e, { holidayId }) => [
        { type: 'HolidayVariants', id: `holiday-${holidayId}` },
      ],
    }),
  }),
});

export const {
  useGetHolidayVariantsQuery,
  useCreateHolidayVariantMutation,
  useUpdateHolidayVariantMutation,
  useDeleteHolidayVariantMutation,
  useSetHolidayVariantDefaultMutation,
} = holidayVariantsApi;
